import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TranslationKey, useTranslator } from '@Localization';
import { IconButton } from '@mui/joy';
import { observer } from 'mobx-react-lite';
interface IProps {
  labelKey: TranslationKey;
  titleEnties: string[];
  count: number;
  onClear: () => Promise<void>;
}

export const FilterPill = observer((props: IProps) => {
  const { t } = useTranslator();

  if (props.count === 0) {
    return <></>;
  }

  return (
    <div
      className='image-filter-pill'
      title={props.titleEnties.join('\n')}
    >
      <span>
        {t(props.labelKey)} <span className='count'>({props.count})</span>
      </span>
      <IconButton
        onClick={() => {
          void props.onClear();
        }}
        className='clear-button'
        size='sm'
      >
        <FontAwesomeIcon icon={faTimes} />
      </IconButton>
    </div>
  );
});
